import { useEffect, useState } from "react";
import {
  useLocation,
  useNavigate,
  useParams
} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container } from "react-bootstrap";
import MailAddressConfirmationModal from "../../components/common/modal/mailAddressConfirmationModal";
import { SearchBannerSection, NonprofitSection } from "./searchDetailsStyle";
import * as Yup from "yup";
import DonateNowModal from "../../components/common/modal/donateNowModal";
import SearchBannerBox from "../../components/common/searchBannerBox";
import OverviewSearchBox from "../../components/common/overviewSearchBox";
import {
  campDetailHandler,
} from "../../redux/slices/donationCamp/campDetail-slice";
import { communityStoriesHandler } from "../../redux/slices/donationCamp/communityStories-slice";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import { MESSAGE } from "../../utils/message";
import { addCartDonateHandler } from "../../redux/slices/donationCamp/addCartDonate-slice";
import MetaComponent from "../../components/common/metaComponent";
import Loader from "../../components/common/Loader/Loader";

const SearchDetails = () => {

  const { slug } = useParams();
  const navigate: any = useNavigate();
  const dispatch: any = useDispatch();
  const { state } = useLocation();
  const [donateNowOpen, setDonateNowOpen] = useState(false);
  const [page, setPage] = useState(1);
  const size = 10;
  const [mailAddressConfirmationOpen, setMailAddressConfirmationOpen] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState<string | number | null>("");
  const [refresh, setRefresh] = useState(false);


  const campDetailsLoading: any = useSelector(
    (state: any) => state?.campDetails?.isLoading
  );

  const campDetails: any = useSelector(

    (state: any) => state?.campDetails?.data?.results
  ) || {};

  
 



  const communityStory: any = useSelector(
    (state: any) => state?.communityStory?.data
  );

  useEffect(() => {
    if (slug) {
      dispatch(campDetailHandler(slug));
    }
  }, [slug]);
  useEffect(() => {
    
    
    if (campDetails?.id) {
      dispatch(communityStoriesHandler(campDetails?.id, selectedFilter, page, size));
    }
  }, [campDetails, page, selectedFilter,refresh]);

 

  // useEffect(() => {
  //   refresh && dispatch(communityStoriesHandler(campDetails?.id, selectedFilter, page, size));
  // }, [refresh]);

  useEffect(() => {
    if (state?.isDonate) {
      setDonateNowOpen(true)
    }
  }, [state]);

  const donationAmount = [
    { id: 1, value: "$50", amount: 50 },
    { id: 2, value: "$100", amount: 100 },

    { id: 3, value: "$250", amount: 250 },
    { id: 3, value: "$500", amount: 500 },
    { id: 3, value: "Other", amount: "" },
  ];
  const formik = useFormik({
    initialValues: {
      org_id: "",
      amount: 250,
    },
    validationSchema: Yup.object({
      amount: Yup.number()
        .required(MESSAGE.requiredErrors("Amount"))
        .min(1, MESSAGE.minDigitErrors("Amount", 1))
        .max(10000000000, MESSAGE.maxDigitErrors("Amount", 10)),
    }),
    onSubmit: (values: { org_id: string; amount: number }, { resetForm }) => {
      const data = {
        org_id: campDetails?.id as string,
        amount: values.amount,
      };
      if (data.amount > 0) {
        dispatch(addCartDonateHandler(data)).then((_: any) => {
          navigate("/donate-now")
        })
        // resetForm({});
      }
    },
  });
  if (campDetailsLoading) {
    return <Loader />
  }



  return (
    <>
      <MetaComponent
        key={`${campDetails?.title}-${campDetails?.state}-${campDetails?.city}`}
        keywords="nonprofits, non-profits, not for profits, volunteer, donate, donation, volunteering, ratings, rate, best non-profits, best nonprofits, best charities, top nonprofits, top charities, top non-profits, charitable giving, giving to nonprofits"
        description="nonprofits, non-profits, not for profits, volunteer, donate, donation, volunteering, ratings, rate, best non-profits, best nonprofits, best charities, top nonprofits, top charities, top non-profits, charitable giving, giving to nonprofits"
        ogTitle={campDetails?.title}
        ogDescription="Volunteer, donate, read reviews for Collegiate Swimming Officials Association Inc in Norwood, MA plus similar nonprofits and charities related to Recreation &amp; Sports, Sports"
        ogUrl="https://qa.greatnonprofits.org/org/collegiate-swimming-officials-association-inc"
        ogImage="https://devcdn.greatnonprofits.org/img/gnp-facebook-share-lg.png"
      />
      <>
        <SearchBannerSection className="search-banner-section">
          <Container className="cont-w">
            <SearchBannerBox
              campDetails={campDetails}
              donationAmount={donationAmount}
              setDonateNowOpen={setDonateNowOpen}
              formik={formik}
              imageSlider={true}
              id={campDetails?.id}
            />
          </Container>
        </SearchBannerSection>

        <NonprofitSection>
          <Container className="cont-w">
            <OverviewSearchBox
              campDetails={campDetails}
              setDonateNowOpen={setDonateNowOpen}
              communityStory={communityStory}
              id={campDetails?.id}
              page={page}
              setPage={setPage}
              selectedFilter={selectedFilter}
              setSelectedFilter={setSelectedFilter}
              setRefresh={setRefresh}
            />
          </Container>
        </NonprofitSection>

        <DonateNowModal
          metadata={{ title: campDetails?.title || "" }}
          editDonateNowOpen={donateNowOpen}
          setDonateNowOpen={setDonateNowOpen}
          donationAmount={donationAmount}
          formik={formik}
        />

        <MailAddressConfirmationModal
          open={mailAddressConfirmationOpen}
          setOpen={setMailAddressConfirmationOpen}
          handleConfirm={() => setMailAddressConfirmationOpen(false)}
          handleEdit={() => { }}
        />
      </>
    </>
  );
};
export default SearchDetails;
